export const environment = {
  production: true,
  apiBaseUrl: '/api'
};
